import { createStore } from 'redux';


const initState = {
    reservatioUnable: false,
}

const Reducer = (state=initState, action) => {
    switch(action.type) {
        case 'SET_RESERVATION_UNABLE':
            return {
                ...state,
                reservatioUnable: true
            }
        case 'SET_RESERVATION_ABLE':
            return {
                ...state,
                reservatioUnable: false
            }
        default:
            return state
    }
}

export const store = createStore(Reducer);